import React from 'react';
import type { FilterMenuOption } from '@goodfynd/ui';
import { Autocomplete } from '@goodfynd/ui';

import { useLotApi } from '../../../hooks/api';

import type { AutocompleteVenuesProps } from './types';

export function AutocompleteVenues({
  idPropertyName = 'nameId',
  ...props
}: AutocompleteVenuesProps) {
  const api = useLotApi();
  return (
    <Autocomplete<FilterMenuOption>
      label="Lot"
      placeholder="Find lot..."
      getOptions={async (request) => {
        try {
          const { results } = await api.autocomplete(request);
          return results.map((result) => ({
            description: result.nameId,
            image: result.image,
            label: [result.organization, result.uniqueName || result.name]
              .filter(Boolean)
              .join(': '),
            value: result[idPropertyName] || result.id,
          }));
        } catch (error) {
          console.error(error);
          return [];
        }
      }}
      {...props}
    />
  );
}
